import { atom } from 'recoil';
import { SetValues } from '../../hooks/useForm/useForm';
import { DEFAULT_VALUES } from '../../../config/defaultValues/defaultValues';

export type SelectRefreshNeededValue = {
  name: string;
  value?: SetValues;
};

export const formSubmitState = atom<boolean>({
  key: 'formSubmitState',
  default: false,
});

export const formSubmitEnabledState = atom<boolean>({
  key: 'formSubmitEnabledState',
  default: true,
});

export const isSelectRefreshNeeded = atom<null | SelectRefreshNeededValue[]>({
  key: 'isSelectRefreshNeeded',
  default: null,
});

export const isDateSelectPreferred = atom<boolean>({
  key: 'isDateSelectPreferred',
  default: DEFAULT_VALUES.isDateSelectPreferred,
});

export const formStepErrorState = atom<boolean>({
  key: 'formStepErrorState',
  default: false,
});
